import { UpdateAccountGroupsApi } from "@/features/accounts/account-group/services/update-account-groups-api";
import { UpdateAccountGroupsRequestModel } from "@/features/accounts/account-group/services/update-account-groups-model";

/// 口座グループ更新
export class UpdateAccountGroupsService {
  private updateAccountGroupsApi = new UpdateAccountGroupsApi();

  /**
   * 口座グループ更新
   */
  public async updateAccountGroups(param: UpdateAccountGroupsRequestModel) {
    return await this.updateAccountGroupsApi.updateAccountGroups(param);
  }
}

